/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Tree_SubtitleInputs */

const en_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus & Start Planting Instantly!`)
};

const ar_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على بلس وابدأ الزراعة فورًا!`)
};

const de_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holen Sie sich Plus und pflanzen Sie sofort!`)
};

const es_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Consigue Plus y empieza a plantar al instante!`)
};

const fr_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenez Plus et commencez à planter dès maintenant !`)
};

const it_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni Plus e inizia subito a piantare!`)
};

const ja_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusを入手して今すぐ植樹しましょう！`)
};

const ko_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 가입하고 지금 바로 나무를 심어 보세요!`)
};

const pt_br_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seja Plus e comece a plantar agora!`)
};

const ru_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте Plus и сразу начинайте посадку!`)
};

const th_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัคร Plus และเริ่มปลูกต้นไม้ได้ในทันที!`)
};

const tr_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus üyeliği edin ve anında ağaç ekmeye başla!`)
};

const zh_cn_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级 Plus 立刻开种`)
};

const zh_tw_daily_paywall_tree_subtitle = /** @type {(inputs: Daily_Paywall_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升級 Plus 立刻開種`)
};

/**
* | output |
* | --- |
* | "Get Plus & Start Planting Instantly!" |
*
* @param {Daily_Paywall_Tree_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_tree_subtitle = /** @type {((inputs?: Daily_Paywall_Tree_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Tree_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_tree_subtitle(inputs)
	if (locale === "ar") return ar_daily_paywall_tree_subtitle(inputs)
	if (locale === "de") return de_daily_paywall_tree_subtitle(inputs)
	if (locale === "es") return es_daily_paywall_tree_subtitle(inputs)
	if (locale === "fr") return fr_daily_paywall_tree_subtitle(inputs)
	if (locale === "it") return it_daily_paywall_tree_subtitle(inputs)
	if (locale === "ja") return ja_daily_paywall_tree_subtitle(inputs)
	if (locale === "ko") return ko_daily_paywall_tree_subtitle(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_tree_subtitle(inputs)
	if (locale === "ru") return ru_daily_paywall_tree_subtitle(inputs)
	if (locale === "th") return th_daily_paywall_tree_subtitle(inputs)
	if (locale === "tr") return tr_daily_paywall_tree_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_tree_subtitle(inputs)
	return zh_tw_daily_paywall_tree_subtitle(inputs)
});